import apiClient from 'clients/apiClient';
import config from 'helpers/config';

const baseURL = `${ config.getApiBaseUrl() }/bookings`;

export const updateBookingAmendRequest = (id, params) => {
    return apiClient.update(`${ baseURL }/${ id }/amend`, params);
};

export const fetchBookingAmendPriceRequest = (id, params) => {
    return apiClient.read(`${ baseURL }/${ id }/amend/price`, params);
};

export const createBookingAmendTransactionRequest = (id, params) => {
    return apiClient.create(`${ baseURL }/${ id }/amend/transactions`, params);
};



// WEBPACK FOOTER //
// ./src/http/requests/bookings/amendBookingsRequests.js